import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { OrganizationsSection } from '../components/OrganizationsSection';
import { PartnersSection } from '../components/PartnersSection';
export function ParticipantesPage() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);
  return <div className="pt-20" data-id="element-473">
      {/* Hero Banner */}
      <section className="relative py-20 md:py-28 bg-brand-navy overflow-hidden" data-id="element-474">
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-475">
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-brand-royal/30 via-brand-navy to-brand-navy" data-id="element-476"></div>
          <motion.div animate={{
          y: [0, -12, 0],
          x: [0, 6, 0]
        }} transition={{
          duration: 7,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute top-1/4 right-1/3 w-56 h-56 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-477" />
          <motion.div animate={{
          y: [0, 15, 0]
        }} transition={{
          duration: 9,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 1.5
        }} className="absolute bottom-1/3 left-1/4 w-72 h-72 bg-brand-crimson/8 rounded-full blur-3xl" data-id="element-478" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-479">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} className="max-w-3xl" data-id="element-480">
            <a href="/" className="inline-flex items-center gap-2 text-white/60 hover:text-brand-gold transition-colors text-sm mb-8 group" data-id="element-481">
              <ArrowLeftIcon className="w-4 h-4 group-hover:-translate-x-1 transition-transform" data-id="element-482" />
              Volver al inicio
            </a>
            <h1 className="text-5xl md:text-7xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-483">
              Nuestros{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-gold to-yellow-200" data-id="element-484">
                Participantes
              </span>
            </h1>
            <p className="text-xl text-white/75 leading-relaxed max-w-2xl" data-id="element-485">
              Organizaciones sociales y empresas aliadas que forman parte de la
              red, trabajando juntos por el fortalecimiento del sector social en
              Ecuador.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Organizaciones Participantes */}
      <OrganizationsSection data-id="element-486" />

      {/* Aliados Estratégicos */}
      <PartnersSection data-id="element-487" />
    </div>;
}